export default "__VITE_ASSET__DddamZZ0__"